<template lang="html">
  <div class="terminal-operate">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.terminal')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.terminalEdit')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="operate-container verifone-panel" >

      <!-- 头部 终端基础信息 -->
      <terminal-edit-head :sn="snNo" :model="modelValue" :deviceId="deviceId" :activeReportTime="activeReportTime"
                          :alertStatus="alertStatus" :pn="pn" :timeZoom="timeZone" />

      <div class="operate-body">

        <el-tabs type="border-card" style="width: 100%">

          <!-- 自定义终端参数编辑面板 -->
          <el-tab-pane :label="$t('message.terminalParam')" class="tp-pane-base">
            <!-- APP列表 start -->
            <div class="operate-left">
              <div class="left-upper">
                <div class="left-header"><span>{{$t('message.appList')}}</span></div>
                <div class="left-body">
                  <el-table ref="singleTable" highlight-current-row width="190" @row-click="appRowClick" @current-change="appSelectedChange"
                  :data="terminalShowApps" :max-height="518" :show-header="false">
                    <el-table-column width="50" property="date">
                      <template slot-scope="scope">
                        <img class="app-icon" :src="scope.row.logo" alt="">
                      </template>
                    </el-table-column>
                    <el-table-column width="120">
                      <template slot-scope="scope">
                         <div>{{scope.row.name}}</div>
                         <div>
                            <el-select v-model="scope.row.selectedVersion" @change="appVersionChange(scope)">
                            <el-option v-for="item in scope.row.versionList" :key="item" :label="item" :value="item"/>
                            </el-select>
                         </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="left-footer">
                <el-button v-if="queryFlag" class="verifone-btn" type="danger" plain icon="el-icon-close" @click="appShowDeleteDialog">
                  {{$t('message.delete')}}
                </el-button>
                <el-button v-else disabled class="verifone-btn" type="danger" plain icon="el-icon-close">
                  {{$t('message.delete')}}
                </el-button>
                <el-button v-if="queryFlag" class="verifone-btn" type="primary" plain icon="el-icon-plus" @click="chooseDialogShow">
                  {{$t('message.add')}}
                </el-button>
                <el-button v-else disabled class="verifone-btn" type="primary" plain icon="el-icon-plus" @click="chooseDialogShow">
                  {{$t('message.add')}}
                </el-button>
              </div>
            </div>
            <!-- APP列表 end -->

            <!-- 终端参数列表 start -->
            <div class="operate-right">
              <h4>{{$t('message.terminalLists')}}</h4>
              <div class="table-container">
                <div class="table-main btn-table">
                  <template>
                    <el-tabs type="card" v-model="atpSelectedTab" class="verifone-tabs" @tab-click="atpTabClick">
                        <el-tab-pane v-for="(item,index) in viewNameList"  :label="item"  :key="index" :name="item"/>
                    </el-tabs>
                    <el-table class="tpTable" :data="atpFilterShowList(paramData,atpSelectedTab)" :max-height="500"
                              tooltip-effect="dark" style="width: 100%">
                        <el-table-column :label="$t('message.databaseName')" prop="dataName"/>
                        <el-table-column prop="value" :label="$t('message.valueEdit')">
                          <template slot-scope="scope"><el-input v-model="scope.row.value" /></template>
                        </el-table-column>
                        <el-table-column prop="description" :label="$t('message.description')" />
                    </el-table>
                  </template>
                </div>
              </div>

              <div class="terminal-footer">
                <span>{{$t('message.totals')}} {{paramData.length - filterCount}} {{$t('message.items')}}</span>
                <div class="submit-container">
                  <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.cancel')}}</el-button>
                  <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="callSave">{{$t('message.submit')}}</el-button>
                  <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
                </div>
              </div>
              <!-- 分页 -->
              <div>
                <el-pagination background
                  layout="prev, pager, next"
                  @current-change="atpPageChange"
                  :current-page="atpCurrentPageNum"
                  :page-count="atpPageCount" />
              </div>
            </div>
            <!-- 终端参数列表 end -->
          </el-tab-pane>

          <!-- 终端基础信息设置页 -->
          <el-tab-pane :label="$t('message.config')">
            <terminal-edit-tab-base-config :model="modelValue" :deviceId="deviceId" :merchantValue="merchantValue" :groupValue="groupValue"
              @emitDeviceId="changeDeviceId" @emitModel="changeModel" @emitMerchant="changeMerchant" @emitGroup="changeGroup"/>
            <div class="submit-container">
              <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.cancel')}}</el-button>
              <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="configSave">{{$t('message.submit')}}</el-button>
              <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
            </div>
          </el-tab-pane>

          <!-- 位置服务 -->
          <el-tab-pane :label="$t('message.locationService')">
            <terminal-edit-location-service :superMoveDistance="distance" :superMoveConf="triggerValue" :terminalLat="terminalLat" :sn = "snNo"
                                            :terminalLng="terminalLng" :queryFlag="queryFlag" :terminalId = "terminalId"
                                            :uploadLocationOperate = "uploadLocationOperate" :locationUploadTime = "locationUploadTime"
                                            :terminalMoveConfigInitialLat = "terminalMoveConfigInitialLat" :terminalMoveConfigInitialLng = "terminalMoveConfigInitialLng"
                                            :superInitLocationSettingType = "initLocationSettingType" :superIsAllowUploadLocationInfo = "isAllowUploadLocationInfo"
                                            :superUploadLocationInfoInterval = "uploadLocationInfoInterval" :superMoveEffectiveTime = "moveEffectiveTime"
                                            :queryLocationTrajectoryOperate = "queryLocationTrajectoryOperate"
                                            @cancel="callBack" @locationServerConfigSave="locationServerConfigSave"
                                            @saveMovingWarnConfig = "saveMovingWarnConfig"
                                            @saveMovingTrackConfig = "saveMovingTrackConfig"
                                            @emitMoveConf="changeMoveConf" @emitMoveDistance="changeMoveDistance"
                                            @emitUploadLocationInfoInterval = "changeUploadLocationInfoInterval"
                                            />
          </el-tab-pane>

          <!-- 上报已安装App面板 -->
          <el-tab-pane :label="$t('message.currentInstall')">
              <terminal-edit-app :installApps="terminalAppInstalls" :lastDiagnosticTime="lastDiagnosticTime"/>
          </el-tab-pane>

          <!-- 上报远程诊断信息面板 -->
          <el-tab-pane :label="$t('message.diagnosticData')">
              <terminal-diagnostic-detail :diagnosticDetail="diagnosticDetail" :lastDiagnosticTime="lastDiagnosticTime"/>
          </el-tab-pane>

          <!-- 相关任务信息面板 -->
          <el-tab-pane :label="$t('message.downloadTask')">
              <terminal-edit-task-list :terminalId="terminalId" />
          </el-tab-pane>

          <!-- 预警面板 -->
          <el-tab-pane :label="$t('message.alert')">
              <terminal-edit-alert :terminalId="terminalId" :queryFlag="queryFlag"/>
          </el-tab-pane>

          <!-- 历史 -->
          <el-tab-pane :label="$t('message.history')">
            <terminal-edit-history :terminalId="terminalId" />
          </el-tab-pane>
        </el-tabs>

      </div>

      <!-- 底部 保存关闭 -->
     <!-- <div class="submit-container">
        <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.cancel')}}</el-button>
        <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="callSave">{{$t('message.submit')}}</el-button>
        <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
      </div> -->
    </div>

    <!-- 删除APP 确认弹框 Start -->
    <el-dialog title="" :visible.sync="deleteDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.deleteApp')}}</span><span>{{deleteAppName}}</span><span>"?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain  @click="deleteDialogVisible =false">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="appDelete">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- 删除APP 确认弹框 End -->

    <!-- 是否创建下载任务 Start -->
    <el-dialog title="" :visible.sync="submitDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.terminalCreateTask')}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="callCreateNo">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="callCreateDownload">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- 是否创建下载任务 End -->

    <!-- APP选择页 Start -->
    <el-dialog :title="$t('message.chooseAppPage')" width="56%" :visible.sync="selectAppDialogVisible">
      <el-table :data="appSelectorTableData" ref="appTable" style="margin-bottom: 20px;">
        <el-table-column type="selection" width="55" />
        <!-- 图标 -->
        <el-table-column prop="icon" :label="$t('message.app')" width="60">
          <template slot-scope="scope">
            <img :src="scope.row.icon" width="36" height="36" />
          </template>
        </el-table-column>
        <!-- App名 -->
        <el-table-column prop="name" width="150" />
        <!-- 版本号 -->
        <el-table-column prop="version" :label="$t('message.version')" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.selectVersion" @change="chooseOptionChange(scope.row)">
              <el-option v-for="item in scope.row.versionList" :key="item" :label="item" :value="item" />
            </el-select>
          </template>
        </el-table-column>
        <!-- 公司名称  -->
        <el-table-column prop="companyName" :label="$t('message.developer')" width="150" />
        <!-- 创建日期 -->
        <el-table-column prop="createTime" :label="$t('message.date')" width="150" />
      </el-table>
      <div class="submit-container">
        <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="chooseCancel">{{$t('message.cancel')}}</el-button>
        <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="chooseSubmit">{{$t('message.submit')}}</el-button>
        <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
      </div>
    </el-dialog>
    <!-- APP选择页 End -->
  </div>
</template>

<script>
  import TerminalEditApp from "./terminal/TerminalEditApp"
  import TerminalEditHead from "./terminal/TerminalEditHead"
  import TerminalEditAlert from "./terminal/TerminalEditAlert"
  import TerminalEditHistory from "./terminal/TerminalEditHistory"
  import TerminalEditTaskList from "./terminal/TerminalEditTaskList"
  import TerminalEditTabBaseConfig from "./terminal/TerminalEditTabBaseConfig"
  import TerminalDiagnosticDetail from "./terminal/TerminalDiagnosticDetail"
  import TerminalEditLocationService from "./terminal/TerminalEditLocationService"

  export default {
    components: {
      TerminalEditHistory,
      TerminalEditAlert,
      TerminalEditLocationService,
      TerminalEditTaskList,
      TerminalEditApp, TerminalDiagnosticDetail, TerminalEditTabBaseConfig, TerminalEditHead},
    inject: ['reload'],
    data() {
      return {
        count: 0,
        selectVersion:'',
        deleteDialogVisible: false,
        submitDialogVisible: false,
        deleteAppName: '',
        deleteAppId: '',
        // operateListTotal: '30',
        historyRow: null,
        queryFlag: false,
        appSelected: [], // 终端关联的APP列表，废弃

        merchantValue:'',
        groupValue: [],

        plsAddingAPP:this.$t('message.plsAddingAPP'),
        deleteSuccess: this.$t('message.deleteSuccess'),
        saveSuccess: this.$t('message.saveSuccess'),
        createSuccess: this.$t('message.createSuccess'),
        inputCheck: this.$t('message.inputCheck'),
        chooseOneApp: this.$t('message.chooseOneApp'),
        tickAPP: this.$t('message.tickAPP'),
        terminalParameterEmpty: this.$t('message.terminalParameterEmpty'),
        locationUploadIntervalError: this.$t('message.locationUploadIntervalError'),



        createTaskAppIdList: [], // 创建下载任务使用的AppId 集合

        // -------------------------------- 基础信息 Start --------------------------------
        snNo: '',
        deviceId: '',
        modelValue: '',
        terminalId: '',
        alertStatus: 99,
        activeReportTime:'',
        pn:'',
        timeZone:'',
        triggerValue: 0,
        distance: '',
        terminalLat:'', // 终端位置：纬度
        terminalLng:'', // 终端位置：经度
        locationUploadTime:'', //位置信息保存时间
        terminalMoveConfigInitialLat: '', // 移机警报初始位置（纬度）
        terminalMoveConfigInitialLng: '', // 移机警报初始位置（纬度）
        isAllowUploadLocationInfo: '0', // 是否允许上送位置信息 0：不允许，1：允许
        uploadLocationInfoInterval:'', // 上送位置信息频率
        initLocationSettingType:"0",
        lastDiagnosticTime:'', // 最后一次上报诊断信息的时间
        terminalAppInstalls:[], // 终端已安装的APP
        diagnosticDetail: [], // 终端诊断信息
        // --------------------------------- 基础信息 End ---------------------------------

        // ------------------------------ App选择页面 Start ------------------------------
        selectAppDialogVisible: false, //App选择界面
        newApps: [], // 有终端模板的最新版本App集合
        allApps: [], // 有终端模板的全部App集合
        // ------------------------------ App选择页面 End ------------------------------


        // ------------------------------ 终端参数 Start ------------------------------
        paramData: [], // 选中App相关参数列表
        viewNameList: [], //tab标签页名集合
        atpSelectedTab: "", // 当前选中的Tab页Lable值
        atpPageCount: 1, // 总页数
        atpCurrentPageNum: 1, // 当前页码
        filterCount: 0, // 被过滤掉不允许显示的参数数量
        operateTerminalParameterMap: new Map(), // 有经过操作的终端参数
        // ------------------------------ 终端参数 End ------------------------------

        // ------------------------------ App列表 Start ------------------------------
        appSelectorTableData:[], // 展示信息
        currentRow: null, //当前选中的App的信息
        terminalShowApps:[], // App列表当前展示的App
        terminalAllApps:[], // App配置的全部App
        deleteTerminalAppMap : new Map(), // 被删除的终端App Map<AppId,App>
        operationTerminalAppMap: new Map(), // 新增或者删除的App Map<AppId,OperationType> OperationType: 0删除，1新增
        appIsChange:0, // 选中的app是否发生变更，0：否，1是；
        changeVersionBeforeCheckApp: [], // 变更app前勾选的app
        // ------------------------------ App列表 End ------------------------------

        // ------------------------------ 界面控制参数 Start ------------------------------
        uploadLocationOperate: false, // 是否允许操作位置上送配置
        queryLocationTrajectoryOperate: false, // 是否允许进行轨迹查询
        // ------------------------------ 界面控制参数 End ------------------------------

        // --------------------------------- 位置 Begin ---------------------------------
        moveEffectiveTime:'',
        // ---------------------------------  位置 End  ----------------------------------
      }
    },
    mounted() {
      this.init();
      this.setQuery();
      this.chooseSearchApps();
      this.getLocationServiceDetail();
    },
    computed: {
      changeData() {
        const {
          deviceId,
          modelOptions,
          merchantOptions,
          groupValue,
          distance,
          triggerValue,
          modelValue,
          merchantValue,
          paramData

        } = this;
        return {
          deviceId,
          modelOptions,
          merchantOptions,
          groupValue,
          distance,
          triggerValue,
          modelValue,
          merchantValue,
          paramData

        }
      }
    },
    watch: {
      changeData: {
        handler(oldVal, newVal) {
          if (oldVal != newVal && newVal.merchantValue == '') {
            this.count == 0;
          } else if (newVal == oldVal) {
            this.count == 0;
          } else {
            this.count++;
          }
        },
        deep: true
      },
      terminalAllApps: 'chooseTableFilter',
      appSelectorTableData: 'checkChangeVersionBeforeApp',
      selectAppDialogVisible: 'appSelectorDialogClosed',
    },
    methods: {
      init() {
        this.snNo = this.$route.params.sn;
        this.terminalId = this.$route.params.id;
      },
      setQuery() {
        let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
        this.queryFlag = !roleArr.includes(41);
      },
      callCreateNo() {
        this.submitDialogVisible = false;
        this.$router.replace('/terminalList');
      },
      // 退出编辑提示
      callBack() {
        console.log("关闭关闭");
        if (this.count > 0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.$router.replace('/terminalList');
          })
        } else {
          this.$router.replace('/terminalList');
        }
      },


      queryTerminalInfo() {
        let that = this,
          obj = {
            sn: that.snNo
          };

        that.$axios({
          method: 'post',
          url: '/marketplace/terminal/detail',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.yjMessage.showErrorMsg(response.data.desc);
            return;
          } else {
            that.diagnosticDetail = !response.data.diagnosticDetail ? [] : response.data.diagnosticDetail;
            that.terminalAppInstalls = !response.data.terminalAppInstalls ? [] : response.data.terminalAppInstalls;
            that.terminalShowApps = !response.data.terminalShowApps ? [] : response.data.terminalShowApps;
            that.terminalAllApps = !response.data.terminalAllApps ? [] : response.data.terminalAllApps;
            that.merchantValue = response.data.merchantId;
            that.modelValue = response.data.model ? response.data.model : 'X990';
            that.groupValue = response.data.groupId instanceof Array ? response.data.groupId : [];
            that.deviceId = response.data.deviceId;
            that.activeReportTime = response.data.activeReportTime;
            that.alertStatus = response.data.alertStatus;
            that.lastDiagnosticTime = response.data.lastDiagnosticTime;
            that.pn = response.data.pn;
            that.timeZone = response.data.timeZone;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      queryAppParam(id) {
        let that = this,
          obj = {
            sn: this.snNo,
            appId: id
          };
        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/app/parameter/list',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            for (let i = 0; i < that.terminalAllApps.length; i++) {
              if (that.terminalAllApps[i].id == that.currentRow.id) {
                that.terminalAllApps[i].paraList = response.data.paraList;
                that.terminalAllApps[i].viewNameList = response.data.viewNameList;
                that.paramData = response.data.paraList;
                that.viewNameList = response.data.viewNameList;
                that.atpSelectedTab = response.data.viewNameList[0];
                that.currentRow.parameters = response.data.paraList;
              }
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      //点击保存
      callSave() {
        let that = this,
          obj = {
            sn: this.snNo,
            paraList: this.paramData,
            model: this.modelValue,
            merchantId: this.merchantValue,
            groupList: this.groupValue,
            deviceId: this.deviceId,
            moveConf: this.triggerValue,
            dataList: [],
            operationTerminalApps: []
          };

      //判断当前行是否为空，导致app连续删除缺少终端参数，暂时注释掉该方法
      if (that.currentRow != null) {
          that.operateTerminalParameterMap.set(that.currentRow.id, that.paramData);
      }

      if(that.operateTerminalParameterMap.size != 0){
        for (let item of that.operateTerminalParameterMap.entries()) {
          let appId = item[0],
            parameters = item[1];
          if(parameters == null || parameters.length <= 0){
            this.$message({
              type: "error",
              message: this.terminalParameterEmpty,
              duration: '3000',
            });
            return;
          }else{
            let data = {
              appId: appId,
              parameterInfoList: parameters
            }
            obj.dataList.push(data);
          }
          }
        }

        if(that.operationTerminalAppMap.size != 0){
          for(let item of that.operationTerminalAppMap.entries()){
            let data = {
              appId: item[0],
              operationType: item[1]
            }

            obj.operationTerminalApps.push(data);
          }
        }
        that.ajaxSave(obj);
      },

      ajaxSave(obj){
        let that = this;
        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/app/param/save',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.$message({
              type: "success",
              message: this.saveSuccess,
              duration: '3000',
            });

            if (response.data.parameterChange == 1) {
              that.createTaskAppIdList = response.data.appIdList;
              that.submitDialogVisible = true;
            } else {
              this.$router.replace('/terminalList');
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      configSave(){
        let that = this;
        let obj = {
          sn: this.snNo,
          paraList: this.paramData,
          model: this.modelValue,
          merchantId: this.merchantValue,
          groupList: this.groupValue,
          deviceId: this.deviceId,
          moveConf: this.triggerValue,
          dataList: [],
          operationTerminalApps: []
        };
        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/app/config/save',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.$message({
              type: "success",
              message: this.saveSuccess,
              duration: '3000',
            });

            if (response.data.parameterChange == 1) {
              that.createTaskAppIdList = response.data.appIdList;
              that.submitDialogVisible = true;
            } else {
              this.$router.replace('/terminalList');
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      callCreateDownload() {
        let obj = {
          sn: this.snNo,
          appIdList: this.createTaskAppIdList
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/app/parameter/downloadtask',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.$message({
              type: "success",
              message: this.createSuccess,
              duration: '3000',
            });

            this.submitDialogVisible = false;
            this.$router.replace('/terminalList');
          }
        }).catch((err) => {
          console.log(err);
        });
      },




      // ------------------------------ APP列表 Start ------------------------------
      // 应用版本切换
      appVersionChange(scope){
        console.log("appVersionChange 开始","操作行:", scope, "选中行：", this.currentRow);

        let that = this,
          rowPackageName = scope.row.packageName,
          rowSelectedVersion = scope.row.selectedVersion;

        // 当前没有选中行，或者当前操作行的包名与选中行的包名不匹配，那么就只替换展示列表数据
        if(!this.currentRow || (this.currentRow.packageName != rowPackageName)){
          this.terminalAllApps.forEach(function(value,index){
            if(rowPackageName == value.packageName && rowSelectedVersion == value.version){
              scope.row.id = value.id;
              scope.row.logo = value.icon;
              scope.row.name = value.name;
              scope.row.version = value.version;
            }
          });
          return;
        }

        // 修改后的终端参数保存
        this.terminalAllApps.forEach(function(value, index){
          if(value.id == scope.row.id){
            value.parameters = that.paramData;
            value.viewNameList = that.viewNameList;
          }
           that.operateTerminalParameterMap.set(scope.row.id, that.paramData); // Map对象 key:appId,value:终端参数集合
        });

        // 替换当先显示数据
        this.terminalAllApps.forEach(function(value,index){
          if(rowPackageName == value.packageName && rowSelectedVersion == value.version){
            // 选中展示APP信息变更
            scope.row.id = value.id;
            scope.row.logo = value.icon;
            scope.row.name = value.name;
            scope.row.version = value.version;

            //终端参数信息变更
            if(!that.operateTerminalParameterMap.get(value.id)){
              that.queryAppParam(value.id);
            }else{
              that.paramData = value.parameters;
              that.viewNameList = value.viewNameList;
              that.atpSelectedTab = value.viewNameList[0];
            }
          }
        });

        that.currentRow = scope.row;
        that.deleteAppName = that.currentRow.name + '_' + that.currentRow.version;
        console.log("appVersionChange 结束","操作行:", scope, "选中行：", this.currentRow);
      },

      // 显示删除确认窗口
      appShowDeleteDialog() {
        if (this.currentRow == null || this.currentRow == '') {
          return;
        } else {
          this.deleteDialogVisible = true;
        }
      },

      // 应用删除
      appDelete(){
        let that = this,
          currentRowId = this.currentRow.id,
          currentRowVersion = this.currentRow.version,
          currentRowPackageName = this.currentRow.packageName;

        // 如果app是刚刚新增的，那么不加删除标记，反之则加删除标记
        let value = that.operationTerminalAppMap.get(currentRowId);
        if(value == 1)
          that.operationTerminalAppMap.delete(currentRowId); // 移除新增标记
        else
          that.operationTerminalAppMap.set(currentRowId, 0); // 标记App被删除


        // 删除terminalAllApps中的数据
        let array = [],
          deleteIndex;
        that.terminalAllApps.forEach(function(app,index){
          if(currentRowId == app.id){
            // 保存被删除的数据
            app.parameters = that.paramData;
            app.viewNameList = that.viewNameList;
            let deleteApp = that.copyObj(app); // 深拷贝
            that.deleteTerminalAppMap.set(currentRowId, deleteApp);

            // 得到要删除项的索引，此处不能直接删除 可能会出现异常
            deleteIndex = index;
          }else if(currentRowPackageName == app.packageName){
            array.push(app);
          }
        });

        // 删除数据
        //console.log("appDelete","currentRow：", that.currentRow, "deleteIndex",deleteIndex, "array:", array);
        that.terminalAllApps.splice(deleteIndex,1);

        // 删掉该版本后，还存在相同包名不同版本的APP的，则替换显示，否则不显示
        if(array.length != 0){
          that.terminalShowApps.forEach(function(app,index){
            if(that.currentRow.id == app.id){
              app.id = array[0].id;
              app.logo = array[0].icon;
              app.name = array[0].name;
              app.version = array[0].version;
              app.selectedVersion = array[0].version;

              let versionIndex;
              app.versionList.forEach(function(version,index){
                if(version == currentRowVersion)
                  versionIndex = index;
              })
              app.versionList.splice(versionIndex,1);
              //删除app后，默认点击一下
              if(!app.paraList)
              that.queryAppParam(that.currentRow.id);
            else{
              that.paramData = app.paraList;
              that.viewNameList = app.viewNameList;
              that.atpSelectedTab = app.viewNameList[0];
              }

            }
          })



        }else{
          let delIndex;
          that.terminalShowApps.forEach(function(app,index){
            if(currentRowId == app.id){
              delIndex = index;
            }
          })
          that.terminalShowApps.splice(delIndex,1);
          //console.log("appDelete","showAppDelIndex：", delIndex, "terminalShowApps:", that.terminalShowApps);
        }

        //删除自定义参数修改历史
        that.operateTerminalParameterMap.delete(currentRowId);

        // 清除数据
        //that.currentRow = null;
        that.paramData = [];
        that.viewNameList = [];

        // 隐藏提示框
        that.deleteDialogVisible = false;
        //刷新提示框的内容
        that.deleteAppName = that.currentRow.name + '_' + that.currentRow.version;

        console.log("deleteTerminalApp",
        "currentRow：", that.currentRow,
        "terminalShowApps：", that.terminalShowApps,
        "terminalAllApps：",that.terminalAllApps,
        "deleteTerminalAppMap：",that.deleteTerminalAppMap,
        "operationTerminalAppMap：", that.operationTerminalAppMap
        );
      },

      // 应用切换
      // 点击其他行时，进行数据保存。
      appSelectedChange(newRow, oldRow) {
        let that = this;
        that.currentRow = newRow;

        if(newRow == null){
          return;
        }

        this.appIsChange = 1;

        // 将修改的数据存起来
        if (oldRow != null && oldRow.parameters != null) {
          that.terminalAllApps.forEach(function(app){
            if (app.id == oldRow.id){
              app.parameters = that.paramData;
              app.viewNameList = that.viewNameList;
            }
          })

          // Map对象 key:appId,value:终端参数集合
          that.operateTerminalParameterMap.set(oldRow.id, that.paramData);
        }

        // 如果终端参数存在 就不用去后台取
        that.terminalAllApps.forEach(function(app){
          if (app.id == newRow.id){
            if(!app.paraList)
              that.queryAppParam(newRow.id);
            else{
              that.paramData = app.paraList;
              that.viewNameList = app.viewNameList;
              that.atpSelectedTab = app.viewNameList[0];
            }
          }
        });

        that.deleteAppName = that.currentRow.name + '_' + that.currentRow.version;
      },

      // 点击app触发
      appRowClick(row){
        let _this = this;

        // 如果选中行发生改变，则不进行任何操作。
        if (_this.appIsChange == 1){
          _this.appIsChange = 0;
          return;
        }

        // 选中行没有发生改变，那么就重新加载终端参数
        _this.terminalAllApps.forEach(function(app){
          if (app.id == row.id){
            if(!app.paraList)
              _this.queryAppParam(row.id);
            else{
              _this.paramData = app.paraList;
              _this.viewNameList = app.viewNameList;
              _this.atpSelectedTab = app.viewNameList[0];
            }
          }
        });
      },

      // ------------------------------ APP列表 End ------------------------------


      // ------------------------------ 终端参数 Start ------------------------------
      // 展示参数过滤
      atpFilterShowList(list, label) {
        let temp = this.yyUtils.filterShowList(list,label,this.atpCurrentPageNum);
        this.atpPageCount = temp.pageCount;
        this.filterCount = temp.filterCount;
        return temp.showList;
      },

      // 终端参数 页码改变事件
      atpPageChange(currentPageNum){
        this.atpCurrentPageNum = currentPageNum;
        this.atpFilterShowList(this.paramData, this.atpSelectedTab);
      },

      // 终端参数Tabs点击事件
      atpTabClick(tab){
        this.atpCurrentPageNum = 1;
        this.atpSelectedTab = tab.label;
      },
      // ------------------------------ 终端参数 End ------------------------------


      // ------------------------------ APP选择页 Start ------------------------------
      // 显示APP选择界面
      chooseDialogShow() {
        this.selectAppDialogVisible = true;
      },

      // 查询用于展示的APP
      chooseSearchApps() {
        let that = this;
        this.$axios({
          method: 'get',
          url: '/marketplace/app/hasTemplate',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          }
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.newApps = response.data.newApps;
            that.allApps = response.data.allApps;
            that.queryTerminalInfo();
            console.log("chooseSearchApps","newApps:", that.newApps, "allApps:", that.allApps);
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // App选择页展示数据过滤
      chooseTableFilter(){
        //console.log("chooseTableFilter","newApps:",this.newApps);
        let that = this;

         // 已配置的APP，Map(packageName,versions)
        let selectedAppMap = new Map();
        this.terminalAllApps.forEach(function(app){
          let versionList = selectedAppMap.get(app.packageName);
          if(!versionList){
            versionList = [app.version];
            selectedAppMap.set(app.packageName,versionList);
          }else{
            versionList.push(app.version);
          }
        });

        let tempShowApps = [];
        this.newApps.forEach(function(app){
          let versionList = selectedAppMap.get(app.packageName);
          if(versionList == undefined){
            tempShowApps.push(app);
          }else{
            // 版本列表中剔除已经被配置过的版本
            let newVersionList = app.versionList.filter(function(version){
               if(!versionList.includes(version))
                  return version;
            });

            // 没有可以用于展示的版本 就不展示该APP
            if(newVersionList.length != 0){
              let showApp = JSON.parse(JSON.stringify(app));  //深拷贝App基础数据
              showApp.versionList = newVersionList;  // 替换展示的版本
              tempShowApps.push(showApp);
            }
          }
        });

        // 存在优先展示的APP已经被配置，但默认列表展示的还是优先展示项的问题，所以需要再过滤一遍数据
        tempShowApps.forEach(function(tempApp){
          // 情况一：展示的App是已经绑定到终端的
          if(!tempApp.versionList.includes(tempApp.selectVersion)){
              let defaultVersion = tempApp.versionList[0];
              that.allApps.forEach(function(app){
                if(app.version == defaultVersion && app.packageName == tempApp.packageName){
                  tempApp.companyName = app.companyName;
                  tempApp.createTime = app.createTime;
                  tempApp.icon = app.icon;
                  tempApp.id = app.id;
                  tempApp.name = app.name;
                  tempApp.version = app.version;
                  tempApp.selectVersion = defaultVersion;
                }
              })
          }

          // 情况二：显示的APP的版本与选中的版本不一致
          if (tempApp.version != tempApp.selectVersion) {
            that.allApps.forEach(function(app){
              if (tempApp.packageName == app.packageName && tempApp.selectVersion == app.version) {
                tempApp.companyName = app.companyName;
                tempApp.createTime = app.createTime;
                tempApp.icon = app.icon;
                tempApp.id = app.id;
                tempApp.name = app.name;
                tempApp.version = app.version;
              }
            })
          }
        });

        console.log("chooseTableFilter","tempShowApps:",tempShowApps);
        that.appSelectorTableData = tempShowApps;
      },

      // 应用新增
      chooseSubmit() {
        // 获取选中的AppId集合
        let that = this,
          selection = that.$refs.appTable.selection;
        console.log("chooseSubmit",selection,that.terminalAllApps,that.terminalShowApps);

        // 无选择提示
        if(selection.length == 0){
          that.$message({
            type: "error",
            message: this.plsAddingAPP,
            duration: '3000',
          });
          return;
        }

        // 收集要添加的AppID
        selection.forEach(function(selectApp,index){
          let operation = that.operationTerminalAppMap.get(selectApp.id),
            app = that.deleteTerminalAppMap.get(selectApp.id);

          console.log("chooseSubmit","selectApp:",selectApp,"operation:",operation,"delApp",app);
          if(typeof(operation)=="undefined"){
            console.log("chooseSubmit","无操记录作全新的APP");

            // 这个是全新的App，操作记录中不存在与其相关的信息
            // 标记为新增
            that.operationTerminalAppMap.set(selectApp.id, 1);

            // terminalAllApps新增
            let newAllApp = {
              id: selectApp.id,
              name: selectApp.name,
              packageName: selectApp.packageName,
              icon: selectApp.icon,
              version: selectApp.version
            }
            that.terminalAllApps.push(newAllApp);

            // terminalShowApps新增
            let isAdd = false;
            that.terminalShowApps.forEach(function(showApp,index){
              if(showApp.packageName == selectApp.packageName){
                showApp.versionList.push(selectApp.version);
                isAdd = true;
              }
            });
            if(!isAdd){
              let newShowApp = that.copyObj(newAllApp);
              newShowApp.logo = selectApp.icon;
              newShowApp.versionList = [selectApp.version];
              newShowApp.selectedVersion = selectApp.version;
              that.terminalShowApps.push(newShowApp);
            }

          }else{
            console.log("chooseSubmit","有操记录非作全新的APP",operation);
            // 该App为刚刚被删除的App，从新添加则移除删除标记 与 被删除的缓存
            that.operationTerminalAppMap.delete(selectApp.id);

             // terminalAllApps新增
            let deleteAllApp = {
              id: app.id,
              name: app.name,
              packageName: app.packageName,
              icon: app.icon,
              version: app.version,
              paraList: app.parameters,
              viewNameList: app.viewNameList
            }
            that.terminalAllApps.push(deleteAllApp);

            // terminalShowApps新增
            let isAdd = false;
            that.terminalShowApps.forEach(function(showApp,index){
              if(showApp.packageName == selectApp.packageName){
                showApp.versionList.push(selectApp.version);
                 isAdd = true;
              }
            });
            if(!isAdd){
              let newDeleteApp = that.copyObj(deleteAllApp);
              newDeleteApp.logo = selectApp.icon;
              newDeleteApp.versionList = [selectApp.version];
              newDeleteApp.selectedVersion = selectApp.version;
              that.terminalShowApps.push(newDeleteApp);
            }
          }

          // 不管怎么样，新增的app都不允许存在删除的记录
          that.deleteTerminalAppMap.delete(selectApp.id);
        });

        console.log("chooseSubmit:",
          "selection:",selection,
          "terminalShowApps:",that.terminalShowApps,
          "terminalAllApps", that.terminalAllApps,
          "deleteTerminalAppMap",that.deleteTerminalAppMap);

        this.changeVersionBeforeCheckApp = [];
        this.selectAppDialogVisible = false;
      },

      // 关闭选择页
      chooseCancel(){
        this.selectAppDialogVisible = false;
      },

      // selectAppDialogVisible 值变更监听
      appSelectorDialogClosed(){
        if (this.selectAppDialogVisible){
          return
        }
        this.$refs.appTable.clearSelection();
        this.changeVersionBeforeCheckApp = [];
      },

      // 版本号切换
      chooseOptionChange(row){
        console.log("进行了App版本切换",row);

        // 更新表格数据
        let _this = this;
        if (row.version != row.selectVersion) {
          _this.allApps.forEach(function(app){
            if (row.packageName == app.packageName && row.selectVersion == app.version) {
              row.companyName = app.companyName;
              row.createTime = app.createTime;
              row.icon = app.icon;
              row.id = app.id;
              row.name = app.name;
              row.version = app.version;
            }
          })
        }

        // 没有勾选项，啥都不做
        let selection =  _this.$refs.appTable.selection;
        if (selection.length == 0) {
          return;
        }

        // 保存勾选项
        _this.changeVersionBeforeCheckApp = [];
        selection.forEach(function(checkApp){
          _this.changeVersionBeforeCheckApp.push(checkApp);
        });
      },

      // 为应对版本号切换导致已勾选项丢失的问题，特进行补勾选的操作
      checkChangeVersionBeforeApp(){
        let _this = this;
        if (_this.changeVersionBeforeCheckApp == []){
          return;
        }

        _this.changeVersionBeforeCheckApp.forEach(function (beforeCheckApp) {
          let packageName = beforeCheckApp.packageName;
          _this.appSelectorTableData.forEach(function (showApp) {
            if (showApp.packageName == packageName){
              _this.$nextTick(() => {
                _this.$refs.appTable.toggleRowSelection(showApp, true);
              });
            }
          })
        });
      },
      // ------------------------------ APP选择页 End ------------------------------

      copyObj(obj){
        return JSON.parse(JSON.stringify(obj));
      },

      changeDeviceId(deviceId){
        this.deviceId = deviceId;
      },

      changeModel(model){
        this.modelValue = model;
      },

      changeMerchant(merchant){
        this.merchantValue = merchant;
      },

      changeGroup(group){
        this.groupValue = group;
      },

      changeMoveConf(moveConf){
        this.triggerValue = moveConf;
      },

      changeMoveDistance(moveDistance){
        this.distance = moveDistance;
      },

      changeUploadLocationInfoInterval(uploadLocationInfoInterval){
        this.uploadLocationInfoInterval = uploadLocationInfoInterval;
      },

      saveMovingWarnConfig(terminalMoveConfigLat, terminalMoveConfigLng, moveEffectiveTime, initLocationSettingType){
        let obj = {
          terminalId: this.terminalId,
          moveConf: this.triggerValue,
          distance: this.distance,
          moveEffectiveTime: moveEffectiveTime,
          terminalMoveConfigInitialLat: terminalMoveConfigLat,
          terminalMoveConfigInitialLng: terminalMoveConfigLng,
          initLocationSettingType: initLocationSettingType
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/locationServerConfig/movingWarn/edit',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.code == "99") {
            this.yjMessage.showErrorMsg(response.data.desc);
            return;
          } else {
            this.yjMessage.showSuccessMsg(this.saveSuccess);
            this.$router.replace('/terminalList');
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      saveMovingTrackConfig(isAllowUploadLocationInfo){
        let obj = {
          terminalId: this.terminalId,
          isAllowUploadLocationInfo: isAllowUploadLocationInfo,
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/locationServerConfig/movingTrack/edit',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.code == "99") {
            this.yjMessage.showErrorMsg(response.data.desc);
            return;
          } else {
            if (response.data.data.isCreateTask == 1){
              this.yjMessage.showSuccessMsg(this.$t('message.locationUploadCreateTaskMsg'));
            } else{
              this.yjMessage.showSuccessMsg(this.saveSuccess);
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },


      locationServerConfigSave(terminalMoveConfigLat, terminalMoveConfigLng, moveEffectiveTime){
        let _this = this;

        /*if(_this.isAllowUploadLocationInfo == 1){
          if (_this.uploadLocationInfoInterval < 5){
            _this.yjMessage.showErrorMsg(_this.locationUploadIntervalError);
            return;
          }
        }*/

        let obj = {
          terminalId: this.terminalId,
          moveConf: this.triggerValue,
          distance: this.distance,
          moveEffectiveTime: moveEffectiveTime,
          terminalMoveConfigInitialLat: terminalMoveConfigLat,
          terminalMoveConfigInitialLng: terminalMoveConfigLng,
          isAllowUploadLocationInfo: this.isAllowUploadLocationInfo,
          uploadLocationInfoInterval: this.uploadLocationInfoInterval,
        };
        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/locationServerConfig/edit',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.code == "99") {
            this.yjMessage.showErrorMsg(response.data.desc);
            return;
          } else {
            if (response.data.data.isCreateTask == 1){
              this.yjMessage.showSuccessMsg(this.$t('message.locationUploadCreateTaskMsg'));
            } else{
              this.yjMessage.showSuccessMsg(this.saveSuccess);
            }
            this.$router.replace('/terminalList');
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      getLocationServiceDetail(){
        let _this = this;
        this.$axios({
          method: 'get',
          url: '/marketplace/terminal/locationServiceDetail/' + this.terminalId,
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          }
        }).then(response => {
          if (response.data.code == "99") {
            this.yjMessage.showErrorMsg(response.data.desc);
            return;
          } else {
            _this.terminalLng = response.data.data.terminalLng;
            _this.terminalLat = response.data.data.terminalLat;
            _this.locationUploadTime = response.data.data.locationUploadTime;
            _this.triggerValue = response.data.data.moveConf;
            _this.distance = response.data.data.distance;
            _this.terminalMoveConfigInitialLat = response.data.data.terminalMoveConfigInitialLat;
            _this.terminalMoveConfigInitialLng = response.data.data.terminalMoveConfigInitialLng;
            _this.isAllowUploadLocationInfo = response.data.data.isAllowUploadLocationInfo;
            _this.uploadLocationInfoInterval = response.data.data.uploadLocationInfoInterval;
            _this.uploadLocationOperate = response.data.data.uploadLocationOperate;
            _this.queryLocationTrajectoryOperate = response.data.data.queryLocationTrajectoryOperate;
            _this.moveEffectiveTime = response.data.data.moveEffectiveTime;
            _this.initLocationSettingType = response.data.data.initLocationSettingType;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
    }
  }
</script>

<style lang="css" scoped="scope">
  .operate-container {
    background-color: #fff;
    padding: 15px;
    margin-top: 20px;
    overflow: auto;
  }

  .operate-header,
  .operate-body,
  .terminal-footer,
  .left-header {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
  }

  .operate-left {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .operate-header {
    justify-content: flex-start;
    height: 20px;
    align-items: center;
  }

  .operate-body {
    justify-content: center;
    /* height: 100px; */
    padding: 20px;
    with: 100%;
  }

  .terminal-footer {
    padding: 10px;
    justify-content: space-between;
  }

  .terminal-footer span {
    font-size: 14px;
    color: #666;
  }

  .operate-left {
    position: relative;
    width: 20%;
    flex-shrink: 0;
    background-color: #f0f0f0;
  }

  .operate-right {
    width: 80%;
    padding-left: 10px;
  }

  .arrow-left {
    width: 22px;
    height: 22px;
  }

  .sn-container {
    margin-left: 20px;
  }

  .operateSave {
    padding: 6px 18px;
    background-color: #58D56D;
    border: 1px solid #58D56D;
  }

  .app-icon {
    width: 38px;
    height: 38px;
  }

  .left-header {
    padding: 8px 20px;
    justify-content: space-between;
    align-items: center;
  }

  .addApp {
    color: #fff;
    background-color: #58D56D;
    padding: 8px;
  }

  .left-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 10px 0px;
  }

  .delete-icon {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 24px;
    height: 25px;
    cursor: pointer;
  }

  tr>td {
    padding: 5px 0 !important;
  }

  .el-input__inner {
    border: 1px solid #fff;
  }

  .terminal-header {
    display: flex;
    flex-direction: row;
    color: #909399;
    font-size: 14px;
  }

  .header-item {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-item span {
    margin-right: 10px;
  }

  .header-item i {
    margin-right: 2px;
  }

  .required-icon {
    color: red;
    font-size: 20px;
  }

  .operate-distance {
    width: 60px;
  }

  .deviceId {
    width: 180px;
  }

  .group-select {
    width: 425px;
  }

  .second-item {
    margin: 10px 5vw 0 20px;
  }

  .trigger-item {
    margin-top: 15px;
  }

  .verifone-tabs {
    padding-top: 15px;
  }

  .tp-pane-base {
    display: flex;
    display: -webkit-flex;
  }

  .diagnostic-title {
    justify-content: space-between;
    border-bottom:1px solid #819bd3;
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/TerminalOperate.vue